import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FullScreenBackground } from "../../compoment/PortraitStage";
import { clearBrowserStorage } from "../../utils/storage";
import newBg from "../../assets/img/new-bg.png";
import typoText from "../../assets/img/typo-text.png";
import btnBg from "../../assets/img/btn-bg.png";
import { ArrowRight } from "../../compoment/icon";
import { useRouteFrozen } from "../../routes/routeTransition";

const IdleScreen = () => {
  const navigate = useNavigate();
  const routeFrozen = useRouteFrozen();

  useEffect(() => {
    if (routeFrozen) return;
    void clearBrowserStorage();
  }, [routeFrozen]);

  const handleStart = () => {
    navigate("/qr-scan", { replace: true, state: { rescan: Date.now() } });
  };

  return (
    <section className="idleSection">
      <FullScreenBackground image={newBg} position="center center" />

      <div className="homeContent">
        <img className="homeTitle" src={typoText} alt="Tree of Wisdom" />
        <p className="homeTagline">Share your wisdom to the world!</p>
        <button
          className="homeStartBtn"
          style={{ backgroundImage: `url(${btnBg})` }}
          onClick={handleStart}
        >
          START NOW
          <ArrowRight />
        </button>
      </div>
    </section>
  );
};

export default IdleScreen;
